import React from 'react';
import { FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function EvaluationsWidget() {
  const navigate = useNavigate();
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-1925">
      <div className="flex items-center justify-between mb-4" data-id="element-1926">
        <h3 className="font-semibold text-gray-900" data-id="element-1927">Mes évaluations</h3>
        <FileText className="h-5 w-5 text-blue-600" data-id="element-1928" />
      </div>
      <div className="border-l-4 border-blue-500 pl-3 py-2 mb-4 flex-1" data-id="element-1929">
        <div className="flex justify-between items-start" data-id="element-1930">
          <div data-id="element-1931">
            <p className="font-medium text-gray-900" data-id="element-1932">
              Évaluation annuelle 2023
            </p>
            <p className="text-sm text-gray-600" data-id="element-1933">Date limite: 15 déc. 2023</p>
          </div>
          <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800" data-id="element-1934">
            En cours
          </span>
        </div>
        <div className="mt-2" data-id="element-1935">
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1936">
            <div className="bg-blue-600 h-2 rounded-full" style={{
            width: '40%'
          }} data-id="element-1937"></div>
          </div>
          <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-1938">
            <span data-id="element-1939">Progression: 40%</span>
            <span data-id="element-1940">2/5 sections complétées</span>
          </div>
        </div>
      </div>
      <button onClick={() => navigate('/evaluations')} className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors duration-150 ease-in-out mt-auto" data-id="element-1941">
        Continuer mon évaluation
      </button>
    </div>;
}